/*
 * @Author: liuxiaoling 
 * @Date: 2021-03-01 15:31:25 
 * @Last Modified by: liuxiaoling
 * @Last Modified time: 2021-03-01 16:11:12
 * @description: 存放项目正则 
 */

export const pattern = (type) => {
    switch (type) {
        // 手机号|座机
        case 'tel':
            return /(^1\d{10}$)|(\d{3,4}-\d{7,8}$)/
            // return /(^1[3|4|5|7|8]\d{9}$)|(0\d{2,3}-\d{7,8}$)/
        // 手机
        case 'mobile':
            return /(^1\d{10}$)/
        // 邮箱
        case 'email':
            return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        // 数字
        case 'number':
            return /^(0|-?[1-9]\d*)\b/g
        default:
            break
    }
}
